type Leveler<T> = (a:T)=>number
type Sorter<T> = (a:T,b:T)=>number

export function composedSorter<T>(... sorters :Sorter<T>[]){
  return function(a :T,b :T){
    for(var i=0;i<sorters.length;i++){
      let partialresult = sorters[i](a,b);
      if(partialresult!==0){
        return partialresult;
      }
    }
    return 0;
  }
}
export function levelSorter<T>(leveler :Leveler<T>) :Sorter<T>{
  return function(a :T,b :T){
    try{
      return (leveler(a)-leveler(b))||0; 
    }catch(e){
      console.log(e);
      return 0;
    }
  };
}
export function reverseSorter<T>(sorter :Sorter<T>) :Sorter<T>{
  return function(a :T,b :T){
    return sorter(b,a);
  };
}